import React, { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function ExportableScorecard({ children }) {
  const ref = useRef(null);

  const downloadImage = async () => {
    const canvas = await html2canvas(ref.current);
    const link = document.createElement("a");
    link.download = "ranked_scorecard.png";
    link.href = canvas.toDataURL();
    link.click();
  };

  const downloadPDF = async () => {
    const canvas = await html2canvas(ref.current);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save("ranked_scorecard.pdf");
  };

  return (
    <div>
      <div ref={ref}>{children}</div>
      <div style={{ marginTop: 20, display: "flex", gap: 10 }}>
        <button onClick={downloadImage}>Save as Image</button>
        <button onClick={downloadPDF}>Download PDF</button>
      </div>
    </div>
  );
}
